<template>
    <div class="page">
        <div class="searchBox">
            <el-form>
                <el-row>
                    <el-col :span="4">
                        <el-form-item>
                            <el-input style="width:130px;margin-right: 10px;" placeholder="订单号/宠物名/负责人"
                                v-model="search.keyword" clearable @keyup.enter.native="changeSearch"
                                size="small"></el-input>
                            <el-button @click="changeSearch" type="warning" size="small">搜索</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <el-form-item label="门店">
                            <el-select style="width: 140px" size="small" class="select" v-model="shopId" placeholder="请选择"
                                @change="changeSearch">
                                <el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name"
                                    :value="item.shop_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="时间" :label-width="'90px'">
                            <el-date-picker type="daterange" v-model="orderPayTime" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" size="small" style="width: 220px"
                                @change="changeSearch">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <resetBtn @reset="reset" style="width:56px;display: inline-block;margin:0px 10px;"></resetBtn>
                        <el-button type="warning" v-if="$buttonAuthority('huoti-charge-add')"  size="small" @click="handelClick">添加</el-button>
                    </el-col>
                    <el-button type="warning" v-if="$buttonAuthority('huoti-charge-derive')" size="small"
                        style="float: right;" @click="handelexportClick">数据导出</el-button>
                </el-row>
            </el-form>
        </div>
        <div class="pageConBox">
            <el-table class="table" :data="tableData" style="width: 100%">
                <el-table-column prop="orderNo" label="订单号"></el-table-column>
                <el-table-column prop="petInfo.petName" label="宠物名字"></el-table-column>
                <el-table-column prop="shopInfo.shopName" label="门店">
                </el-table-column>
                <el-table-column label="饲养">
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.dataList" :key="index" v-show="item.staffType == 5">
                            <span> {{ item.staffInfo.userName }} {{ item.performanceMoney }}
                                <el-button v-show="$buttonAuthority('huoti-charge-royaltyedit')" icon="el-icon-edit"
                                    @click="edit(item)" type="text" size="small"></el-button>
                                <el-button v-show="$buttonAuthority('huoti-charge-royaltydel')" icon="el-icon-delete"
                                    @click="del(item)" type="text" size="small"></el-button>
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="医生">
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.dataList" :key="index" v-show="item.staffType == 1">
                            <span> {{ item.staffInfo.userName }} {{ item.performanceMoney }}
                                <el-button v-show="$buttonAuthority('huoti-charge-royaltyedit')" icon="el-icon-edit"
                                    @click="edit(item)" type="text" size="small"></el-button>
                                <el-button v-show="$buttonAuthority('huoti-charge-royaltydel')" icon="el-icon-delete"
                                    @click="del(item)" type="text" size="small"></el-button>
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="医助">
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.dataList" :key="index" v-show="item.staffType == 2">
                            <span> {{ item.staffInfo.userName }} {{ item.performanceMoney }}
                                <el-button v-show="$buttonAuthority('huoti-charge-royaltyedit')" icon="el-icon-edit"
                                    @click="edit(item)" type="text" size="small"></el-button>
                                <el-button v-show="$buttonAuthority('huoti-charge-royaltydel')" icon="el-icon-delete"
                                    @click="del(item)" type="text" size="small"></el-button>
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="洗美">
                    <template slot-scope="scope">
                        <div v-for="(item, index) in scope.row.dataList" :key="index" v-show="item.staffType == 3||item.staffType ==4">
                            <span> {{ item.staffInfo.userName }} {{ item.performanceMoney }}
                                <el-button v-show="$buttonAuthority('huoti-charge-royaltyedit')" icon="el-icon-edit"
                                    @click="edit(item)" type="text" size="small"></el-button>
                                <el-button v-show="$buttonAuthority('huoti-charge-royaltydel')" icon="el-icon-delete"
                                    @click="del(item)" type="text" size="small"></el-button>
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="时间">
                    <template slot-scope="scope">{{ $public.FTime(scope.row.orderPayTime, "YYYY-MM-DD") }}</template>
                </el-table-column>
                <el-table-column label="详情">
                    <template slot-scope="scope">
                        <el-button @click="see(scope.row)" type="text" size="small">查看</el-button>

                    </template>
                </el-table-column>
            </el-table>

            <page :total="page.total" :page="page.page" @change="changePage" style="padding-bottom: 10px;"></page>
        </div>
        <el-dialog title="编辑" :modal-append-to-body="false" :visible.sync="dialogconfirm_state" width="20%">
            <el-form>
                <el-form-item label="奖金">
                    <el-input type="input" v-model.number="money"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogconfirm_state = false">取 消</el-button>
                <el-button type="warning" @click="confirmSort">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 添加 -->
        <div v-if="panelState">
      <panelAdd
        @submit="submit_drawerStatus"
      ></panelAdd>
    </div>
    </div>
</template>
  
<script>
import resetBtn from "../../components/resetBtn.vue";
import page from "@/components/page.vue";
import axios from 'axios';
import panelAdd from "./panel/panel_royalty.vue";
export default {
    components: { resetBtn, page,panelAdd },
    data() {
        return {
            search: {
                keyword: "",
            },
            page: {
                page: 1,
                pageSize: 10,
                total: 0
            },
            shopList: this.$store.state.myShopList,
            shopId: "",
            tableData: [],
            dialogconfirm_state: false,
            orderPayTime: [],
            money: 0,
            id: '',
            panelState:false,
        }
    },
    mounted() {
        this.getInitializeDate()
        this.getTableData();
      
    },
    methods: {
        handelClick(){
            this.panelState = true;
        },
        submit_drawerStatus() {
      this.panelState = false;
      this.getTableData();
    },
        // 下载预警列表
        handelexportClick() {
            let params = {
                shopId: this.shopId,
                keyword: this.keyword,

            };
            if (this.orderPayTime && this.orderPayTime.length == 2) {
                params.beginTime = ("" + new Date(this.orderPayTime[0]).getTime()).substr(0, 10);
                params.endTime = ("" + new Date(this.orderPayTime[1]).getTime()).substr(0, 10);
            }
            axios({
                method: 'post',
                url: process.env.VUE_APP_Url9 + 'api/StaffPerformanceDetail/GetPetHeadListExcel',
                responseType: 'blob',
                data: params,
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data], {
                        type: "application/ms-excel"
                    }));
                    const link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = url;
                    link.setAttribute('download', `负责人.xls`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                })
        },
        getInitializeDate() {
            let myDate = new Date();
            let month = myDate.getMonth() + 1;
            month = month < 10 ? "0" + month : month;   //格式化月份，补0
            let statDateStart = myDate.getFullYear().toString() + '-' + month + "-01"; //月初
            let dayEnd = new Date(myDate.getFullYear(), month, 0).getDate(); //获取当月一共有多少天
            let statDateEnd = myDate.getFullYear().toString() + '-' + month + '-' + dayEnd; //月末
            console.log(statDateStart, "ppp");   //20230101
            console.log(statDateEnd);     //20230131
            this.orderPayTime = [statDateStart, statDateEnd];
        },
        see(row) {
            let query = {
                id: row.petInfo.petId,
            };
            this.$router.push({
                path: "/huotiZongcang/detail", query,
            });
        },
        del(item) {
            let params = {
                id: item.id,
            }
            this.$http.get(process.env.VUE_APP_Url9 + 'api/StaffPerformanceDetail/Delete', params).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        message: '已删除',
                        type: 'success'
                    });
                }
                this.getTableData()
            })
        },
        edit(item) {
            this.id = item.id
            this.money = item.performanceMoney,
                this.dialogconfirm_state = true
        },

        // 确定
        confirmSort() {
            let params = {
                id: this.id,
                money: this.money,
            }
            this.$http.get(process.env.VUE_APP_Url9 + 'api/StaffPerformanceDetail/UpdateMoney', params).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        message: '已修改',
                        type: 'success'
                    });
                    this.dialogconfirm_state = false
                }
                this.getTableData()
            })
        },
        getTableData() {
            let params = {
                shopId: this.shopId,
                pageIndex: this.page.page,
                pageSize: this.page.pageSize,
                keyword: this.search.keyword,
            }
            if (this.orderPayTime && this.orderPayTime.length == 2) {
                params.startTime = ("" + new Date(this.orderPayTime[0]).getTime()).substr(0, 10);
                params.endTime = ("" + new Date(this.orderPayTime[1]).getTime()).substr(0, 10);
            }
            let loading = this.$loading();
            this.$http
                .post(
                    process.env.VUE_APP_Url9 + "api/StaffPerformanceDetail/GetPetHeadList",
                    params
                )
                .then((res) => {
                    loading.close();
                    if (res.code == 0) {
                        this.tableData = res.data.data;
                        this.page.total = res.data.count;
                    }
                })
        },
        // 改变分页
        changePage(num) {
            this.page.page = num;
            this.getTableData();
        },
        changeSearch() {
            this.page.page = 1;
            this.getTableData()
        },

        // 重置筛选
        reset() {
            this.page.page = 1;
            this.search.keyword = '';
            this.shopId = '';
            this.getTableData();
        }
    }
}
</script>
  
<style scoped lang="scss">
.page {
    .searchView {
        .tabLine {
            display: flex;

            .tabItem {
                width: 88px;
                box-sizing: border-box;
                line-height: 36px;
                text-align: center;
                border-right: 1px solid #f2f2f2;
                cursor: pointer;
                font-size: 14px;
                background-color: #fff;

                &.active {
                    color: $mainColor;
                }
            }
        }

        .searchBox {
            border-top: 1px solid #f2f2f2;
        }
    }

    .content {
        padding: 0 0px;
        min-height: 600px;

        ::v-deep .el-form-item {
            margin-bottom: 0;

            .el-form-item__label {
                padding-right: 5px;
                font-size: 12px;
            }
        }
    }
}</style>